import React from 'react'

import GamesNavBar from '../../components/GamesNavBar'
import useCategory from '../../components/GamesNavBar/hooks/useCategory'
import useSearch from '../../components/GamesNavBar/hooks/useSearch'
import CategoriesGrid from './CategoriesGrid'
import SelectedGamesGrid from './SelectedGamesGrid'
import { CATEGORIES_GRID_TEST_ID, GAMES_GRID_TEST_ID } from './constants'
import { Wrapper } from './styles/Wrapper'
import { shouldRenderCategoriesGrid } from './utils'

export function GamesBlockWithData() {
  const { search } = useSearch()
  const { category: selectedCategory } = useCategory()

  const renderCategoriesGrid = shouldRenderCategoriesGrid({
    selectedCategory,
    isSearching: search.length > 0,
  })

  return (
    <Wrapper>
      <GamesNavBar />
      <SelectedGamesGrid
        hide={renderCategoriesGrid}
        testId={GAMES_GRID_TEST_ID}
      />
      <CategoriesGrid
        hide={!renderCategoriesGrid}
        testId={CATEGORIES_GRID_TEST_ID}
      />
    </Wrapper>
  )
}
